/**
 * computeSyncStatusBadge (868m3rv4t) decides a switch/router row's status
 * badge, branching on pollMode first.
 *
 * CONTROLLER-mode rows (868m2z7an): pollStatus is deliberately frozen at
 * its last real agent-poll value once a device flips to CONTROLLER
 * ownership -- controller.sync.cjs's applyControllerHealth never writes it,
 * on purpose, since pollStatus is exclusively the agent's own reported
 * status. Showing pollStatus here for a CONTROLLER row would display
 * whatever the agent last said (often UNREACHABLE, since a failing agent
 * poll is exactly what usually causes the flip to CONTROLLER in the first
 * place) forever, regardless of how healthy the device actually is via the
 * controller. isOnline is the real, live signal for these rows -- generic
 * across every manufacturer/controller type, never checked here.
 *
 * AGENT-mode rows keep the original pollStatus-based mapping, unchanged.
 *
 * @param {{ pollMode?: string, isOnline?: boolean, pollStatus?: string }} row
 * @returns {{ color: string, bg: string, label: string }}
 */
export function computeSyncStatusBadge({ pollMode, isOnline, pollStatus }) {
  if (pollMode === 'CONTROLLER') {
    return isOnline
      ? { color: 'var(--accent-primary, #00d4aa)', bg: 'rgba(0,212,170,0.12)', label: 'Online' }
      : { color: '#ef4444', bg: 'rgba(239,68,68,0.12)', label: 'Offline' };
  }

  const POLL_STATUS_MAP = {
    OK: { color: 'var(--accent-primary, #00d4aa)', bg: 'rgba(0,212,170,0.12)', label: 'OK' },
    SYNCING: { color: '#60a5fa', bg: 'rgba(96,165,250,0.12)', label: 'Syncing' },
    ERROR: { color: '#ef4444', bg: 'rgba(239,68,68,0.12)', label: 'Error' },
    AUTH_FAILED: { color: '#f59e0b', bg: 'rgba(245,158,11,0.12)', label: 'Auth Failed' },
    UNREACHABLE: { color: '#ef4444', bg: 'rgba(239,68,68,0.12)', label: 'Unreachable' },
    NEVER_SYNCED: { color: '#6b7280', bg: 'rgba(107,114,128,0.12)', label: 'Never Synced' },
    RATE_LIMITED: { color: '#f59e0b', bg: 'rgba(245,158,11,0.12)', label: 'Rate Limited' },
  };
  return POLL_STATUS_MAP[pollStatus] || POLL_STATUS_MAP.NEVER_SYNCED;
}
